import { Component, Input } from "@angular/core";
import { WorkForceWorkOrderStage } from "@interfaces/workForceWorkOrderStage.interface";

@Component({
	moduleId: module.id,
	selector: "workForceWorkOrderStagesDetails",
	styleUrls: ["workForceWorkOrderStagesDetails.css"],
	templateUrl: "workForceWorkOrderStagesDetails.html"
})
export class WorkForceWorkOrderStagesDetailsComponent {
	@Input() plannedStages: WorkForceWorkOrderStage[] = [];
}